// extracted by mini-css-extract-plugin
module.exports = {"iconMoreButton":"ActionComponentV2_iconMoreButton__13zv4","action-title":"ActionComponentV2_action-title__r6U9_","menu-options":"ActionComponentV2_menu-options__GZz2Y"};